import { render, staticRenderFns } from "./CustomDemo.vue?vue&type=template&id=37b53bf5&scoped=true"
import script from "./CustomDemo.vue?vue&type=script&lang=js"
export * from "./CustomDemo.vue?vue&type=script&lang=js"
import style0 from "./CustomDemo.vue?vue&type=style&index=0&id=37b53bf5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b53bf5",
  null
  
)

export default component.exports